import React, {Component} from "react";
import { Checkbox, Tabs, Row, Col, List, Card, Icon, Button, Modal } from 'antd';

import { Scrollbars } from 'react-custom-scrollbars'

import styles from './index.css'
import Item from 'antd/lib/list/Item';

const CheckboxGroup = Checkbox.Group;
const TabPane = Tabs.TabPane;

export default class ChooseBed extends React.Component {
    constructor() {
        super()
        this.state = {
            activeFloor: 'all',
            visible: false,
            curRoomInfo:null,
            curBedInfo:null
        }
    }

    handleChangeFloor = (value) => {
        this.setState({
            activeFloor: value
        })
    }

    showModal = (curRoomInfo,curBedInfo) => {
        this.setState({
            visible: true,
            curRoomInfo,
            curBedInfo
        });
        
    }
    handleOk = (e) => {
        this.setState({
            visible: false,
        });
    }
    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    }


    render() {
        const { curRoomInfo,curBedInfo } = this.state
        const priceTypeOpt = [
            { label: '1200元/年', value: '1' },
            { label: '1400元/年', value: '2' },
            { label: '1600元/年', value: '3' },
        ];

        const roomTypeOpt = [
            { label: '4人间', value: '1' },
            { label: '6人间', value: '2' },
            { label: '8人间', value: '3' },
            { label: '10人间', value: '4' },
            { label: '12人间', value: '5' },
        ];

        const floorType = [
            { name: '全部', value: 'all' },
            { name: '楼层：1', value: '1' },
            { name: '楼层：2', value: '2' },
            { name: '楼层：3', value: '3' },
            { name: '楼层：4', value: '4' },
            { name: '楼层：5', value: '5' },
            { name: '楼层：6', value: '6' },
        ]

        const data = [
            {
                title: 'A1-201',
                bedList: [
                    {
                        id: 1,
                        name: '01床',
                        status: '0',
                    }, {
                        id: 2,
                        name: '02床',
                        status: '1',
                    }, {
                        id: 3,
                        name: '03床',
                        status: '0'
                    }, {
                        id: 4,
                        name: '04床',
                        status: '0'
                    }
                ],
                priceType: '1200',
                total: 4,
                choosen: 1
            }, {
                title: 'A1-202',
                bedList: [
                    {
                        id: 1,
                        name: '01床',
                        status: '0',
                    }, {
                        id: 2,
                        name: '02床',
                        status: '1',
                    }, {
                        id: 3,
                        name: '03床',
                        status: '1'
                    }, {
                        id: 4,
                        name: '04床',
                        status: '0'
                    }, {
                        id: 5,
                        name: '05床',
                        status: '0'
                    }, {
                        id: 6,
                        name: '06床',
                        status: '0'
                    }, {
                        id: 7,
                        name: '07床',
                        status: '1'
                    }, {
                        id: 8,
                        name: '08床',
                        status: '0'
                    }, {
                        id: 9,
                        name: '09床',
                        status: '0'
                    }, {
                        id: 10,
                        name: '10床',
                        status: '0'
                    }, {
                        id: 11,
                        name: '11床',
                        status: '0'
                    }, {
                        id: 12,
                        name: '12床',
                        status: '0'
                    }, {
                        id: 13,
                        name: '13床',
                        status: '0'
                    }
                ],
                priceType: '1200',
                total: 10,
                choosen: 1
            }, {
                title: 'A1-201',
                bedList: [
                    {
                        id: 1,
                        name: '01床',
                        status: '0',
                    }, {
                        id: 2,
                        name: '02床',
                        status: '1',
                    }, {
                        id: 3,
                        name: '03床',
                        status: '0'
                    }, {
                        id: 4,
                        name: '04床',
                        status: '0'
                    }
                ],
                priceType: '1200',
                total: 4,
                choosen: 1
            }, {
                title: 'A1-201',
                bedList: [
                    {
                        id: 1,
                        name: '01床',
                        status: '0',
                    }, {
                        id: 2,
                        name: '02床',
                        status: '1',
                    }, {
                        id: 3,
                        name: '03床',
                        status: '0'
                    }, {
                        id: 4,
                        name: '04床',
                        status: '0'
                    }
                ],
                priceType: '1200',
                total: 4,
                choosen: 1
            }, {
                title: 'A1-201',
                bedList: [
                    {
                        id: 1,
                        name: '01床',
                        status: '1',
                    }, {
                        id: 2,
                        name: '02床',
                        status: '1',
                    }, {
                        id: 3,
                        name: '03床',
                        status: '1'
                    }, {
                        id: 4,
                        name: '04床',
                        status: '1'
                    }
                ],
                priceType: '1200',
                total: 4,
                choosen: 4
            }, {
                title: 'A1-201',
                bedList: [
                    {
                        id: 1,
                        name: '01床',
                        status: '0',
                    }, {
                        id: 2,
                        name: '02床',
                        status: '2',
                    }, {
                        id: 3,
                        name: '03床',
                        status: '0'
                    }, {
                        id: 4,
                        name: '04床',
                        status: '0'
                    }
                ],
                priceType: '1200',
                total: 4,
                choosen: 0
            },{
                title: 'A1-201',
                bedList: [
                    {
                        id: 1,
                        name: '01床',
                        status: '0',
                    }, {
                        id: 2,
                        name: '02床',
                        status: '2',
                    }, {
                        id: 3,
                        name: '03床',
                        status: '0'
                    }, {
                        id: 4,
                        name: '04床',
                        status: '0'
                    }
                ],
                priceType: '1200',
                total: 4,
                choosen: 0
            },{
                title: 'A1-201',
                bedList: [
                    {
                        id: 1,
                        name: '01床',
                        status: '0',
                    }, {
                        id: 2,
                        name: '02床',
                        status: '2',
                    }, {
                        id: 3,
                        name: '03床',
                        status: '0'
                    }, {
                        id: 4,
                        name: '04床',
                        status: '0'
                    }
                ],
                priceType: '1200',
                total: 4,
                choosen: 0
            }
        ]

        return (
            <div 
            style={{ padding: 16, margin: 12, background: '#fff' }}
            >
                <div>
                    选择价格：<CheckboxGroup options={priceTypeOpt} defaultValue={['1']} />
                </div>
                <div style={{ margin: '30px 0' }}>
                    选择房间：<CheckboxGroup options={roomTypeOpt} />
                </div>
                <Row>
                    <Col xl={2} lg={4} md={4} style={{ marginTop: 12 }}>选择床位：</Col>
                    <Col xl={22} lg={20} md={20}>
                        <Tabs defaultActiveKey="1" >
                            <TabPane tab="A11" key="1">
                                <div className={styles.content}>
                                    <div className={styles.floor}>
                                        <ul>
                                            {floorType.map(item =>
                                                <li
                                                    className={item.value == this.state.activeFloor ? styles.active : null}
                                                    key={item.value}
                                                    onClick={() => this.handleChangeFloor(item.value)}>{item.name}</li>
                                            )}
                                        </ul>
                                    </div>
                                    <div className={styles.room}>
                                        <div className={styles.room_box}>
                                            {
                                                data.map((item, index) => {
                                                    return (
                                                        <div 
                                                            style={{float:'left',width:170,margin:8}}
                                                            className={item.choosen == item.total ? styles.card_disabled : null}>
                                                            <Card
                                                                bodyStyle={{ padding: 0 }}
                                                                hoverable
                                                                actions={[<div><Icon type="pay-circle-o" /> <span style={{ color: '#ff177f' }}>{item.priceType}</span>元/年</div>, <b>{item.choosen}/{item.total}</b>]}
                                                            >
                                                                <Card.Meta
                                                                    title={
                                                                        <div style={{ textAlign: 'center' }}>
                                                                            <a href="javascript:;"
                                                                                className={item.choosen == 0 ? styles.title_normal : styles.title_choosen}
                                                                            >{item.title}</a>
                                                                        </div>
                                                                    }
                                                                    description={(
                                                                        <div style={{display:'table',width:'100%'}}>
                                                                            <div className={styles.bed_list}>
                                                                                {item.bedList.map(i =>
                                                                                    <span key={i.id} className={i.status == '1' ? styles.choosen : i.status == '2' ? styles.cur_selected : null} onClick={() => this.showModal(item,i)}></span>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                />
                                                            </Card>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </TabPane>
                        </Tabs>
                    </Col>
                </Row>
                <Modal
                    width={400}
                    title="选择房间"
                    visible={this.state.visible}
                    okText="保存"
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    <div style={{textAlign:'center'}}>
                        <h2 style={{marginBottom:15,fontWeight:'bold',fontSize:16}}>确定选择<a href="javascript:;">{curRoomInfo && curRoomInfo.title}</a>房间的以下床位？</h2>
                        <p style={{color:'#ff177f'}}>{curBedInfo && curBedInfo.name}</p>
                        <p style={{marginBottom:12}}>{curRoomInfo && curRoomInfo.priceType}元/年</p>
                        <div style={{width:170,margin:'0 auto',display:'table'}}>
                            <div className={styles.bed_list} style={{height:'auto'}}>
                                {curRoomInfo && curRoomInfo.bedList.map(i =>
                                    <span key={i.id} className={i.status == '1' ? styles.choosen : curBedInfo.id==i.id ? styles.cur_selected : null}></span>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal>
                <div style={{ textAlign: 'center', marginTop: 20 }}>
                    <Button type="primary">保存</Button>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/chooseBed/index.js